import * as React from 'react';
import { connect } from 'react-redux';

import BaseReportingPage from '../base/BaseReportingPage';
import OnsitePerformance from '../../components/onsite-performance/OnsitePerformance';
import OnsitePerformanceSummary from '../../components/onsite-performance-summary/OnsitePerformanceSummary';
import PageHeading from 'components/page/page-heading/PageHeading';

import { fetchOnsitePerformance, resetOnsitePerformance } from '../../reducers/onsite-performance';

import { __t, applyTranslations } from 'utils/language';

import type { OnsitePerformanceData } from 'modules/reporting/types';

applyTranslations(require('./onsite-performance-page.i18n.json'));

import './onsite-performance-page.scss';

import type { Params } from 'types';

type StateProps = {
  onsitePerformance: OnsitePerformanceData,
  hasContent: boolean,
  isLoading: boolean
};

type DispatchProps = {
  dispatchFetchOnsitePerformance: (campaignId: number) => void,
  dispatchResetOnsitePerformance: () => void
};

type OwnProps = {
  params: Params
};

type Props = OwnProps & StateProps & DispatchProps;

const OnsitePerformancePage = ({
  params,
  onsitePerformance,
  hasContent,
  isLoading,
  dispatchFetchOnsitePerformance,
  dispatchResetOnsitePerformance
}: Props): JSX.Element => {
  const campaignId = Number(params.id);
  const hasData = hasContent && onsitePerformance.influencerProfiles?.length > 0;

  React.useEffect(() => {
    if (campaignId) {
      dispatchFetchOnsitePerformance(campaignId);
    }

    return dispatchResetOnsitePerformance;
  }, [campaignId]);

  return (
    <BaseReportingPage
      headline={__t('onsite_performance_page.page_heading')}
      params={params}
    >
      <div className="onsite-performance-page__heading">
        <PageHeading
          heading={__t('onsite_performance_page.page_heading')}
          color="light"
          size="h1"
          margin="none"
        />
      </div>
      <OnsitePerformanceSummary
        hasData={hasData}
        isLoading={isLoading}
        summary={onsitePerformance.summary}
      />
      <OnsitePerformance
        hasData={hasData}
        isLoading={isLoading}
        onsitePerformance={onsitePerformance}
      />
      {
        !isLoading && !hasData && (
          <section className="onsite-performance-page__empty-message">
            {__t('onsite_performance_page.no_data')}
          </section>
        )
      }
    </BaseReportingPage>
  );
};

const mapStateToProps = ({ onsitePerformance, reportingMetaInfo }): StateProps => ({
  isLoading: reportingMetaInfo.isLoading || onsitePerformance.isLoading,
  hasContent: Boolean(reportingMetaInfo.metaInfo.campaignDeliverableTypes.length),
  onsitePerformance: onsitePerformance.data
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchOnsitePerformance: (campaignId: number) => dispatch(fetchOnsitePerformance(campaignId)),
  dispatchResetOnsitePerformance: () => dispatch(resetOnsitePerformance())
});

export default connect(mapStateToProps, mapDispatchToProps)(OnsitePerformancePage);
